import React from 'react';
import useDebugInformation from '../../../../../hooks/useDebugInformation';
import { useAppSelector } from "@store/hooks";
import Stage1Panel from './Stage1Panel';
import Stage2Panel from './Stage2Panel/index';
import Stage3Panel from './Stage3Panel';

const name = "LeftPanel"

const getPanel = (stage: number, parent: string, prefix?: string, problemsTabsList?: string) => {
    let problemsTabs = [];
    if (problemsTabsList) problemsTabs = JSON.parse(problemsTabsList)
    switch (stage) {
        case 1:
            return (<Stage1Panel parent={parent} />)
        case 2:
            // extract the tab names from the tabs list
            const tabNames = problemsTabs && problemsTabs.length > 1 && problemsTabs?.map((tab: { label: string }) => tab.label)
            return (<Stage2Panel parent={parent} prefix={tabNames || prefix || ""} />)
        case 3:
            return (<Stage3Panel parent={parent} prefix={prefix || ""} />)

        default:
            return (<Stage1Panel parent={parent} />);
    }
}

type Props = {
    parent: string
}

const LeftPanel: React.FC<Props> = ({ parent }) => {
    const activeStep = useAppSelector(({ ui }) => ui.ActiveStep)
    const problemsTabsList = useAppSelector(({ ui }) => ui.ProblemTabsList)
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent, activeStep, problemsTabsList })

    return (getPanel(activeStep + 1, debugName, activeStep === 1 ? "Property" : "", problemsTabsList));
}

LeftPanel.displayName = name;


export default React.memo(LeftPanel)